import "react-datepicker/dist/react-datepicker.css";
import { Button } from "../../Button";
import { PropTypes } from "prop-types";
import SimpleSearch from "../../SimpleSearch";
import { useEffect, useRef, useState } from "react";
import { StyledUserSearchActions, StyledUserSearchOptions } from "../../../styles/StyledUserSearch/StyledUsearSearch";
import { StyledField } from "../../../styles/StyledField";
import { Select } from "../../Select";
import { Checkbox } from "../../Checkbox";
import { useQuery } from "react-query";
import { QueryLoader } from "../../Loader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function SelectableMultiplePeople({ id, choosenPeople, setChoosenPeople, fetchPeople, children, name }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [phrase, setPhrase] = useState(null);
	const { isLoading, isError, error, data } = useQuery([`membersPeopleTab${name}`, phrase, id, name], () =>
		fetchPeople(axiosPrivate, phrase, id)
	);
	const [resultData, setResultData] = useState([]);

	const [unit, setUnit] = useState(null);
	const [unitList, setUnitList] = useState(null);
	const unitRef = useRef();

	const [isChoosen, setIsChoosen] = useState();

	useEffect(() => {
		if (!isLoading && !isError) {
			const res = unit
				? data.filter((e) => [...e.organizationUnits.map((f) => parseInt(f.organizationUnit.id) === parseInt(unit))].includes(true))
				: data;
			const tempChoosenPeople = {};
			for (const person of res) {
				tempChoosenPeople[person.id] = false;
			}
			setChoosenPeople({ ...tempChoosenPeople, ...choosenPeople });
			setResultData(res);
			const units = [];
			data.map((e) =>
				e.organizationUnits.map((f) => {
					const found = units.find((i) => i.id === f.organizationUnit.id);
					if (!found) units.push(f.organizationUnit);
				})
			);
			setUnitList(units);
			let tempIsChoosen = false;
			Object.keys(choosenPeople).map((key) => {
				if (key) tempIsChoosen = true;
			});
			setIsChoosen(tempIsChoosen);
		} else if (isError) {
			console.log(error);
		}
	}, [isLoading, data, unit]);

	const changeSelectedUnit = (label, value) => {
		setUnit(value);
	};

	return (
		<>
			<StyledUserSearchOptions>
				<SimpleSearch isWhite setPhrase={setPhrase} value={phrase} />
				{/* Narrows the list to people who are in the chosen unit */}
				<div className="filter">
					<div className="filter-header">
						<h5>Filter</h5>
						<Button
							onClick={() => {
								setPhrase(null);
								setUnit(null);
								if (unitRef.current) {
									if (unitRef.current.props.value) {
										unitRef.current.props.value.value = null;
										unitRef.current.props.value.label = null;
									}
								}
							}}
							bg={false}
							small={true}
						>
							Clear filters
						</Button>
					</div>
					{unitList && (
						<StyledField edit={true}>
							<label>Unit</label>
							<Select
								options={unitList.map((el) => {
									return { value: el.id, label: el.name };
								})}
								value={unit}
								onChange={changeSelectedUnit}
								id="unit"
								name="unit"
								data-testid="unit"
								ref={unitRef}
							/>
						</StyledField>
					)}
				</div>
			</StyledUserSearchOptions>
			{isLoading || isError ? (
				<QueryLoader />
			) : (
				<StyledUserSearchActions>
					<div className="items">
						{resultData.map((e, i) => {
							if (!choosenPeople[e.id])
								return (
									<label className="item" key={i} htmlFor={`choosePerson-${i}`}>
										<Checkbox
											name={`choosePerson-${i}`}
											changeHandler={() => {
												setChoosenPeople({ ...choosenPeople, [e.id]: e });
												let isAdded = false;
												for (const key in choosenPeople) {
													if (choosenPeople[key] || !choosenPeople[e.id]) isAdded = true;
												}
												setIsChoosen(isAdded);
											}}
											value={choosenPeople[e.id] ? true : false}
										/>
										{e.firstName} {e.lastName}
									</label>
								);
						})}
					</div>
					{isChoosen ? (
						<div className="items items--choosen">
							{Object.keys(choosenPeople).map((key, i) => {
								const e = choosenPeople[key];
								if (e)
									return (
										<label className="item" key={i} htmlFor={`choosenPerson-${i}`}>
											<Checkbox
												name={`choosenPerson-${i}`}
												changeHandler={() => {
													const res = { ...choosenPeople, [e.id]: false };
													setChoosenPeople({ ...choosenPeople, [e.id]: false });
													let isAdded = false;
													for (const key in res) {
														if (res[key]) isAdded = true;
													}
													setIsChoosen(isAdded);
												}}
												value={choosenPeople[e.id] ? true : false}
											/>
											{e.firstName} {e.lastName}
										</label>
									);
							})}
						</div>
					) : (
						""
					)}
					{children && children}
				</StyledUserSearchActions>
			)}
		</>
	);
}

SelectableMultiplePeople.propTypes = {
	refetch: PropTypes.func,
	fetchPeople: PropTypes.func,
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	choosenPeople: PropTypes.any,
	setChoosenPeople: PropTypes.any,
	children: PropTypes.any,
	name: PropTypes.any,
};
